import React, { useCallback, useEffect, useState, useContext } from 'react';
import AuthContext from "../../../../context/auth-context"
import axios from 'axios'
import { Dialog } from '@mui/material';
import { CircularProgress } from "@mui/material"
import { IconButton } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import SmsIcon from '@mui/icons-material/Sms';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';

function SignerAnalysisDataDialog(props) {

    const {
        open,
        setOpen,
        signerNotificationsSelected,
        setSignerNotificationsSelected,
    } = props

    const statesToInitial = useCallback(() => {
        setSignerNotificationsSelected(undefined)
    }, [setSignerNotificationsSelected])

    const onCloseDialog = useCallback(() => {
        statesToInitial()
        setOpen(false)
    }, [statesToInitial, setOpen])

    const userRoles = useContext(AuthContext).user_data.roles

    const [loading, setLoading] = useState(false)
    const [signerNotifications, setSignerNotifications] = useState(null)

    const fetchSignerNotifications = useCallback(() => {
        setLoading(true)
        const timer = setTimeout(() => {
            axios.get(`/dash/notifications/notifications?signer_key=${signerNotificationsSelected.signer_key}`)
                .then((response) => {
                    setSignerNotifications(response.data?.data)
                })
                .catch((error) => {
                    setSignerNotifications(null)
                })
                .finally(() => {
                    setLoading(false)
                })
        }, 500)
        return () => {
            clearTimeout(timer)
        }
    }, [signerNotificationsSelected.signer_key])

    useEffect(() => {
        if (userRoles.includes("list_signer_notifications")) {
            return fetchSignerNotifications()
        }
    }, [userRoles, fetchSignerNotifications])

    const mapEnvelopeTemplate = (template) => {
        switch (template) {
            case 'sign_request':
                return 'Solicitação de assinatura'
            case 'authentication_message':
                return 'Código de autentificação'
            case 'authentication_code':
                return 'Código de autentificação'
            case 'envelope_completed':
                return 'Finalização de assinatura'
            case 'sign_receipt':
                return 'Comprovante de assinatura'
            case 'request_signature_message':
                return 'Solicitação de assinatura'
            case 'signature_receipt_message':
                return 'Comprovante de assinatura'
            case 'envelope_receipt_message':
                return 'Comprovante de assinatura'
            case 'envelope_receipt_message_temporary':
                return 'Comprovante de assinatura'
            case 'envelope_completed_message':
                return 'Finalização de assinatura'
            case 'signer_batch_request_message':
                return 'Solicitação de assinatura em lote'
            case 'signer_batch_receipt_message':
                return 'Comprovante de assinantura em lote'
            case 'completed_signer_batch_message':
                return 'Finalização de assinatura em lote'
            case 'watcher_envelope_submitted_message':
                return 'Acompanhamento de assinatura'
            case 'watcher_envelope_completed_message_v2':
                return 'Acompanhamento de assinatura'
            case 'request_signature_v2':
                return 'Solicitação de assinatura'
            case 'request_signature_document_name':
                return 'Solicitação de assinatura'
            default:
                return '';
        }
    }

    const mapEmailStatus = (status) => {
        switch (status) {
            case 'sent':
                return 'Enviado'
            case 'dispatched':
                return 'Solicitação de envio'
            case 'hard_bounce':
                return 'Bloqueado permanentemente'
            case 'bounce':
                return 'Bloqueado temporariamente'
            case 'spam':
                return 'Spam'
            case 'unsub':
                return 'Cancelou inscrição'
            case 'blocked':
                return 'Bloqueado'
            case 'open':
                return 'Aberto'
            case 'click':
                return 'Clique realizado'
            case 'cancelled':
                return 'Cancelado'
            default:
                return '';
        }
    }

    const mapEmailStatusDescription = (status) => {
        switch (status) {
            case 'sent':
                return 'O e-mail foi enviado com sucesso.'
            case 'dispatched':
                return 'Envio de e-mail está sendo processado.'
            case 'hard_bounce':
                return 'E-mail foi bloqueado permanentemente pelo provedor externo.'
            case 'bounce':
                return 'E-mail foi bloqueado temporariamente pelo provedor externo.'
            case 'spam':
                return 'E-mail foi enviado para caixa de spam.'
            case 'unsub':
                return 'O usuário cancelou a inscrição do e-mail.'
            case 'blocked':
                return 'E-mail foi bloqueado pelo provedor.'
            case 'open':
                return 'E-mail foi aberto pelo usuário.'
            case 'click':
                return 'Usuário clicou no link do e-mail.'
            case 'cancelled':
                return 'E-mail foi cancelado pelo provedor.'
            default:
                return '';
        }
    }

    const mapWhatsAppStatus = (status) => {
        switch (status) {
            case 'delivered':
                return 'Mensagem enviada'
            case 'dispatched':
                return 'Solicitação de envio'
            case 'submitted':
                return 'Provedor solicitou o envio'
            case 'rejected':
                return 'Mensage rejeitada'
            case 'undeliverable':
                return 'Mensagem bloqueada'
            case 'read':
                return 'Mensagem lida'
            case 'cancelled':
                return 'Mensagem cancelada'
            default:
                return '';
        }
    }

    const mapWhatsAppStatusDescription = (status) => {
        switch (status) {
            case 'delivered':
                return 'Mensagem enviada com sucesso.'
            case 'dispatched':
                return 'Envio da mensagem está sendo processado.'
            case 'submitted':
                return 'Provedor requisitou envio de mensagem para o Whatsapp.'
            case 'rejected':
                return 'Provedor rejeitou a mensagem.'
            case 'undeliverable':
                return 'Mensagem não pode ser enviada devido a um bloqueio externo.'
            case 'read':
                return 'Mensagem foi lida pelo usuário.'
            case 'cancelled':
                return 'Mensagem foi cancelada pelo provedor.'
            default:
                return '';
        }
    }

    const mapNotificationIcon = (type) => {
        switch (type) {
            case 'email':
                return <AlternateEmailIcon style={{ color: '#0b1f82' }} />
            case 'sms':
                return <SmsIcon style={{ color: '#0b1f82' }} />
            case 'whatsapp':
                return <WhatsAppIcon style={{ color: '#0b1f82' }} />
            default:
                return <AlternateEmailIcon style={{ color: '#0b1f82' }} />
        }
    }

    const notificationsWithEvents = (signerNotifications || [])
    .filter(
        (notification) =>
        Array.isArray(notification.status_events) &&
        notification.status_events.length > 0
    )

    return (
        <Dialog
            open={open}
            onClose={() => onCloseDialog()}
            fullWidth
            maxWidth={'sm'}
        >
            <div className="dialog__column-container">
                <header style={{ marginBottom: '10px' }}>
                    <h1 style={{ fontSize: '22px', color: "#0b1f82" }}>Notificações</h1>
                    <IconButton
                        onClick={() => onCloseDialog()}
                    >
                        <CloseIcon />
                    </IconButton>
                </header>
                <div style={{ marginBottom: '20px' }}>
                    <p>
                        <span style={{ fontSize: '16px' }}><strong>Nome:</strong></span>
                        <span style={{ fontSize: '16px', marginLeft: '10px' }}>{signerNotificationsSelected.name}</span>
                    </p>
                </div>

                {
                    loading ?
                        <div className='inbox__body_d_block'>
                            <div className="page-container">
                                <p className="message__container message__container--centered">
                                    <span className="message__text">
                                        Buscando notificações ...
                                    </span>
                                    <CircularProgress style={{ color: "#525252", width: "20px", height: "20px", margin: "10px auto" }} />
                                </p>
                            </div>
                        </div>
                        : signerNotifications
                            ? notificationsWithEvents.length > 0 ?
                                <div className='inbox__body_d_block'>
                                    {
                                        notificationsWithEvents.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)).map((notification) => {
                                            const uniqueStatusEvents = Object.values(
                                                (notification.status_events ?? []).reduce((acc, curr) => {
                                                    const currentKey = notification.notification_type === 'email' ? curr.email_status : curr.whatsapp_status
                                                    if (!acc[currentKey] || new Date(curr.event_date) > new Date(acc[currentKey].event_date)) {
                                                        acc[currentKey] = curr
                                                    }
                                                    return acc
                                                }, {})
                                            ).sort((a, b) => new Date(b.event_date) - new Date(a.event_date))
                                            return (
                                                <div className='inbox__body_d_block'>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                                                        <div style={{ display: 'flex' }}>
                                                            <div style={{ display: 'flex', alignItems: 'center', marginRight: '20px' }}>
                                                                {
                                                                    mapNotificationIcon(notification.notification_type)
                                                                }
                                                            </div>
                                                            <div>
                                                                <span style={{ color: '#888', marginBottom: '10px' }}>Assunto</span>
                                                                <h2>{mapEnvelopeTemplate(notification.template)} </h2>
                                                            </div>
                                                        </div>
                                                        {notification.recipient_data &&
                                                            <div>
                                                                <span style={{ color: '#888' }}>Destinatário:</span>
                                                                <h3 style={{ marginTop: '5px' }}>
                                                                    {notification.recipient_data?.email ? notification.recipient_data?.email
                                                                        : notification.recipient_data?.phone ? `${notification.recipient_data.phone.international_dial_code} (${notification.recipient_data.phone.area_code}) ${notification.recipient_data.phone.number.slice(0, 5)}-${notification.recipient_data.phone.number.slice(5, 9)}` : ''}
                                                                </h3>
                                                            </div>
                                                        }
                                                    </div>
                                                    {
                                                        notification.notification_type === 'email' &&
                                                        <div style={{ padding: '10px 30px 0px 30px' }}>
                                                            <Timeline align="left" style={{ padding: '0' }}>
                                                                {uniqueStatusEvents.map((event, index) => (
                                                                    <TimelineItem style={{ minHeight: '30px' }}>
                                                                        <TimelineOppositeContent style={{ flex: '0.05', padding: '0', paddingTop: '5px', paddingRight: '10px' }} >
                                                                            <Typography color="textSecondary" ><strong>{moment(event.event_date).format('DD/MM/YYYY')}</strong></Typography>
                                                                            <Typography color="textSecondary">{moment(event.event_date).format('HH:mm:ss')}</Typography>
                                                                        </TimelineOppositeContent>
                                                                        <TimelineSeparator>
                                                                            <TimelineDot style={{ padding: 2, backgroundColor: "#0b1f82" }} />
                                                                            {index <= uniqueStatusEvents.length - 2 && <TimelineConnector style={{ backgroundColor: "#0b1f82" }} />}
                                                                        </TimelineSeparator>
                                                                        <TimelineContent style={{ flex: '0.95', padding: '0', paddingTop: '5px', paddingLeft: '10px' }}>
                                                                            <Typography style={{ marginBottom: '5px' }}><strong>{mapEmailStatus(event.email_status)}</strong></Typography>
                                                                            <Typography style={{ marginBottom: '5px' }}>{mapEmailStatusDescription(event.email_status)}</Typography>
                                                                            <hr style={{ color: '#0b1f82' }} />
                                                                        </TimelineContent>
                                                                    </TimelineItem>
                                                                ))}
                                                            </Timeline>
                                                        </div>
                                                    }
                                                    {notification.notification_type === 'whatsapp' &&
                                                        <div style={{ padding: '10px 30px 0px 30px' }}>
                                                            <Timeline align="left" style={{ padding: '0' }}>
                                                                {uniqueStatusEvents.map((event, index) => (
                                                                    <TimelineItem style={{ minHeight: '30px' }}>
                                                                        <TimelineOppositeContent style={{ flex: '0.05', padding: '0', paddingTop: '5px', paddingRight: '10px' }} >
                                                                            <Typography color="textSecondary" ><strong>{moment(event.event_date).format('DD/MM/YYYY')}</strong></Typography>
                                                                            <Typography color="textSecondary">{moment(event.event_date).format('HH:mm:ss')}</Typography>
                                                                        </TimelineOppositeContent>
                                                                        <TimelineSeparator>
                                                                            <TimelineDot style={{ padding: 2, backgroundColor: "#0b1f82" }} />
                                                                            {index <= uniqueStatusEvents.length - 2 && <TimelineConnector style={{ backgroundColor: "#0b1f82" }} />}
                                                                        </TimelineSeparator>
                                                                        <TimelineContent style={{ flex: '0.95', padding: '0', paddingTop: '5px', paddingLeft: '10px' }}>
                                                                            <Typography style={{ marginBottom: '5px' }}><strong>{mapWhatsAppStatus(event.whatsapp_status)}</strong></Typography>
                                                                            <Typography style={{ marginBottom: '5px' }}>{mapWhatsAppStatusDescription(event.whatsapp_status)}</Typography>
                                                                            <hr style={{ color: '#0b1f82' }} />
                                                                        </TimelineContent>
                                                                    </TimelineItem>
                                                                ))}
                                                            </Timeline>
                                                        </div>
                                                    }
                                                </div>
                                            )
                                        })

                                    }
                                </div> : <div>Notificações estão indisponíveis para este assinante</div>
                            : <div>Notificações estão indisponíveis para este assinante</div>
                }
            </div>

        </Dialog>
    )
}

export default SignerAnalysisDataDialog